// Notify me on a sold-out variant (sprint plan 5C Task 5; parts/Lifecycle Edge States "Modal · Back-in-stock notify"). The
// buy box shows the button while the variant on screen cannot be bought (ns-product.js sends ns:variant on each change); the
// dialog (ns-notify-popup) posts the email, consent and that variant to the campaign Worker through the app proxy, which
// emails once when the variant is back in stock. D6: email only.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function notifyBody({ variantId, email, consent, locale }) {
  const variant = String(variantId ?? '');
  const value = String(email ?? '').trim();
  if (!EMAIL.test(value) || value.length > 254) return { ok: false, error: 'email' };
  if (consent !== true) return { ok: false, error: 'consent' };
  if (!/^\d{1,20}$/.test(variant)) return { ok: false, error: 'server' };
  return { ok: true, body: { variantId: variant, email: value, consent: true, locale: String(locale || 'en').slice(0, 12) } };
}

// Only a 2xx that says saved is a sign-up. A 409 means the variant can be bought now, a 503 not_ready that the emails are
// not open yet (the Worker's LIFECYCLE_READY is off); anything else is the error message.
export function notifyView(status, json) {
  if (status >= 200 && status < 300 && json?.saved === true) return 'done';
  if (status === 409 && json?.reason === 'available') return 'available';
  if (status === 503 && json?.error === 'not_ready') return 'unavailable';
  return 'error';
}

export const variantOf = (doc, formId) => String(doc.getElementById(formId)?.querySelector('input[name="id"]')?.value ?? '');
// A catalog-mode page has no buy form, so the dialog carries its variant (data-variant) for that case.
export const dialogVariant = (doc, dialog) => variantOf(doc, dialog.dataset.form) || String(dialog.dataset.variant ?? '');

const outside = (rect, x, y) => x < rect.left || x > rect.right || y < rect.top || y > rect.bottom;

function show(dialog, view) {
  for (const node of dialog.querySelectorAll('[data-ns-notify-view]')) node.hidden = node.dataset.nsNotifyView !== view;
}

function open(dialog) {
  const form = dialog.querySelector('form');
  form.reset();
  form.querySelector('[type="submit"]').disabled = false;
  dialog.querySelector('[data-ns-notify-error]').hidden = true;
  show(dialog, 'form');
  dialog.showModal();
  form.elements.email?.focus();
}

if (typeof document !== 'undefined') {
  let pending = false;
  document.addEventListener('ns:variant', event => {
    const buyable = event.detail?.buyable;
    for (const row of document.querySelectorAll('[data-ns-notify-row]')) row.hidden = buyable !== false;
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const opener = target.closest('[data-ns-notify-open]');
    if (opener) { const dialog = document.getElementById(opener.dataset.nsNotifyOpen); if (dialog) open(dialog); return; }
    if (target.closest('.ns-notify [data-ns-notify-close]')) { target.closest('dialog').close(); return; }
    if (target.matches('dialog.ns-notify') && outside(target.getBoundingClientRect(), event.clientX, event.clientY)) target.close();
  });
  document.addEventListener('submit', async event => {
    const form = event.target instanceof Element ? event.target.closest('.ns-notify__form') : null;
    if (!form) return;
    event.preventDefault();
    const dialog = form.closest('dialog');
    const error = dialog.querySelector('[data-ns-notify-error]');
    const checked = notifyBody({ variantId: dialogVariant(document, dialog), email: form.elements.email.value, consent: form.elements.consent.checked, locale: document.documentElement.lang });
    if (!checked.ok) {
      error.textContent = error.dataset[checked.error];
      error.hidden = false;
      form.elements[checked.error]?.focus();
      return;
    }
    if (pending) return;
    pending = true;
    const submit = form.querySelector('[type="submit"]');
    submit.disabled = true;
    error.hidden = true;
    let view = 'error';
    try {
      const response = await fetch(dialog.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(checked.body) });
      view = notifyView(response.status, await response.json().catch(() => null));
    } catch { /* the error message below */ } finally {
      pending = false;
      submit.disabled = false;
    }
    if (view === 'done') {
      show(dialog, 'done');
      dialog.querySelector('[data-ns-notify-heading]').focus();
      return;
    }
    error.textContent = error.dataset[view === 'available' ? 'available' : view === 'unavailable' ? 'unavailable' : 'server'];
    error.hidden = false;
  });
}
